import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Testimony from '../testimony'
import Header from '../header'
import PageBanner from '../pageBanner'
//import Banner from '../banner'
import Subscribtion from '../subscribtion/index'
import BookMeeting from '../booking'
import Contact from '../contact'
import Footer from '../footer'
import logo from '../../images/logo.png'
import footerStyles from './../footer/styles.module.scss'
import './styles.css'

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }

      allContentfulTestimonies(sort: { fields: date, order: DESC }, limit: 1) {
        edges {
          node {
            id
            author
            designation
            image {
              file {
                url
              }
            }
            testimony {
              json
            }
          }
        }
      }
      contentfulContact {
        title
        description {
          json
        }
      }
      contentfulBookMeeting {
        title
        description {
          json
        }
      }
      allContentfulFooter {
        edges {
          node {
            id
            title
            image {
              file {
                url
              }
            }
            url
          }
        }
      }
      contentfulFooterAddress {
        title
        copyright
        buildingNumber
        streetName
        postalCode
        zipCode
        country
      }
    }
  `)
  const allTestimonials = data.allContentfulTestimonies.edges.map(
    ({ node }) => (
      <Testimony
        key={node.id}
        content={documentToReactComponents(node.testimony.json)}
        author={node.author}
        designation={node.designation}
        img={node.image.file.url}
      />
    ),
  )

  const allFooter = data.allContentfulFooter.edges.map(({ node }) => (
    <Footer
      key={node.id}
      url={node.url}
      img={node.image.file.url}
      alt={node.title}
    />
  ))
  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 1920,
          // padding: `0 1.0875rem 1.45rem`,
        }}
      >
        <PageBanner />
        <main>
          {children}
          {allTestimonials}
          <BookMeeting
            title={data.contentfulBookMeeting.title}
            content={documentToReactComponents(
              data.contentfulBookMeeting.description.json,
            )}
          />
          <Contact
            title={data.contentfulContact.title}
            content={documentToReactComponents(
              data.contentfulContact.description.json,
            )}
          />
        </main>
        <div className={footerStyles.mainfooter}>
          <footer className={footerStyles.footerdiv}>
            <div className={footerStyles.footertext}>
              <h3>{data.contentfulFooterAddress.title}</h3>
              <div>
                <div>{data.contentfulFooterAddress.buildingNumber}</div>
                <div>{data.contentfulFooterAddress.streetName}</div>
                <div>{data.contentfulFooterAddress.postalCode}</div>
                <div>{data.contentfulFooterAddress.zipCode}</div>
                <div>{data.contentfulFooterAddress.country}</div>
              </div>
            </div>
            <div className={footerStyles.subscribe}>
              <Subscribtion />
            </div>
            <div className={footerStyles.footericon}>{allFooter}</div>
          </footer>
          <div className={footerStyles.dateDiv}>
            <div className={footerStyles.footerText}>
              {data.contentfulFooterAddress.copyright}{' '}
              {new Date().getFullYear()}
            </div>
            <div className={footerStyles.developedBy}>
              <a href="https://www.integrify.io/en/" target="blank">
                <p>Developed By Integrify</p>
                <img
                  src={logo}
                  alt="integrify logo"
                  className={footerStyles.logo}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
Layout.propTypes = {
  children: PropTypes.node.isRequired,
}
export default Layout
